import { useState } from "react";

import { downloadBook } from "@/data/download-book";
import { offlineAvailable } from "@/lib/appWorker";

const savedKey = (bookId: string): string => `yarn-saved-book:${bookId}`;

function readSaved(bookId: string): boolean {
  try {
    return localStorage.getItem(savedKey(bookId)) !== null;
  } catch {
    return false;
  }
}

/** In the installed app, saves a whole book so it plays with no connection. */
export function DownloadBookButton({ bookId }: { bookId: string }) {
  const [state, setState] = useState(readSaved(bookId) ? "Saved for offline. Save again" : "");
  const [busy, setBusy] = useState(false);
  if (!offlineAvailable()) {
    return null;
  }
  const save = async (): Promise<void> => {
    setBusy(true);
    try {
      const failed = await downloadBook(bookId, (done, total) => {
        setState(`Saving ${done} of ${total}`);
      });
      if (failed === 0) {
        localStorage.setItem(savedKey(bookId), new Date().toISOString());
        setState("Saved for offline. Save again");
      } else {
        setState(`${failed} files could not be saved. Try again`);
      }
    } catch {
      setState("Could not save. Try again");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      type="button"
      className="book-hero__download"
      disabled={busy}
      onClick={() => {
        void save();
      }}
    >
      {state === "" ? "Save for offline" : state}
    </button>
  );
}
